import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppLayout } from './components/layout/app-layout';
import { Homepage } from './pages/homepage';
import { CustomersPage } from './pages/customers';
import { CustomerDetailPage } from './pages/customer-detail';
import { TransactionsPage } from './pages/transactions';
import {
  PaymentsPage,
  ReceiptsDashboard,
  AllocationWorkspace,
  RecordPaymentPage,
  PaymentHistoryPage,
  UnappliedPaymentsPage,
  PaymentExceptionsPage,
  DirectDebitsPage,
  ReconciliationPage
} from './pages/payments';
import CollectionsDashboard from './pages/collections/dashboard';
import CollectionsQueue from './pages/collections/queue';
import PromisesPage from './pages/collections/promises';
import AgeingAnalysisPage from './pages/collections/ageing-analysis';
import DisputesDashboardPage from './pages/disputes/dashboard';
import DisputesAllPage from './pages/disputes/all';
import { CreditScoringPage } from './pages/credit-scoring';
import { SettingsLayout, CompanySettingsPage, DocumentTemplatesPage, TemplateEditorPage, StrategiesPage, StrategyEditorPage } from './pages/settings';
import DisputeTypesPage from './pages/settings/dispute-types';
import { UsersPage } from './pages/users';
import { IntegrationsPage } from './pages/integrations';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route index element={<Homepage />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="customers/:customerId" element={<CustomerDetailPage />} />
          <Route path="transactions" element={<TransactionsPage />} />

          {/* Payments Module Routes */}
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="payments/receipts" element={<ReceiptsDashboard />} />
          <Route path="payments/allocate/:receiptId" element={<AllocationWorkspace />} />
          <Route path="payments/record" element={<RecordPaymentPage />} />
          <Route path="payments/history" element={<PaymentHistoryPage />} />
          <Route path="payments/unapplied" element={<UnappliedPaymentsPage />} />
          <Route path="payments/exceptions" element={<PaymentExceptionsPage />} />
          <Route path="payments/direct-debits" element={<DirectDebitsPage />} />
          <Route path="payments/reconciliation" element={<ReconciliationPage />} />

          {/* Collections Module Routes */}
          <Route path="collections/dashboard" element={<CollectionsDashboard />} />
          <Route path="collections/queue" element={<CollectionsQueue />} />
          <Route path="collections/promises" element={<PromisesPage />} />
          <Route path="collections/ageing-analysis" element={<AgeingAnalysisPage />} />

          {/* Dispute Management Routes */}
          <Route path="disputes" element={<DisputesDashboardPage />} />
          <Route path="disputes/all" element={<DisputesAllPage />} />

          {/* Credit Scoring & Risk Assessment Route */}
          <Route path="credit-scoring" element={<CreditScoringPage />} />

          {/* Settings Module Routes */}
          <Route path="settings" element={<SettingsLayout />}>
            <Route path="company" element={<CompanySettingsPage />} />
            <Route path="templates" element={<DocumentTemplatesPage />} />
            <Route path="strategies" element={<StrategiesPage />} />
            <Route path="dispute-types" element={<DisputeTypesPage />} />
          </Route>

          {/* Template Editor - Full Screen Route (outside SettingsLayout) */}
          <Route path="settings/templates/edit" element={<TemplateEditorPage />} />
          <Route path="settings/templates/create" element={<TemplateEditorPage />} />

          {/* Strategy Editor - Full Screen Route (outside SettingsLayout) */}
          <Route path="settings/strategies/edit" element={<StrategyEditorPage />} />
          <Route path="settings/strategies/create" element={<StrategyEditorPage />} />

          {/* User Management Route */}
          <Route path="users" element={<UsersPage />} />

          {/* System Integrations Route */}
          <Route path="integrations" element={<IntegrationsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
